module.exports = __webpack_public_path__ + "static/media/icon_gpa-calculator.66e5c228.svg";